import { useState } from "react"
import DynamicFilterBar from "../../../../components/common/AdminCommonComponents/FilterBars/DynamicFilterBar/DynamicFilterBar"
import LightGrayBgWrapper from "../../../../components/common/AdminCommonComponents/LightGrayBgWrapper/LightGrayBgWrapper"
import Roles from "../../../../components/AdminPortalComponents/UserManagement/Admins/Roles/Roles"
import Permissions from "../../../../components/AdminPortalComponents/UserManagement/Admins/Permissions/Permissions"
import AdminsTab from "../../../../components/AdminPortalComponents/UserManagement/Admins/Admins/Admins"
import CustomPermissions from "../../../../components/AdminPortalComponents/UserManagement/Admins/CustomPermissions/CustomPermissions"
import ActivityLog from "../../../../components/AdminPortalComponents/UserManagement/Admins/ActivityLog/ActivityLog"

const Admins = () => {
  const tabs = [
    { key: "roles", label: "Roles" },
    { key: "permissions", label: "Permissions" },
    { key: "admins", label: "Admins" },
    { key: "customPermissions", label: "Custom Permissions" },
    { key: "activityLog", label: "Activity Log" },
  ]

  const [activeTab, setActiveTab] = useState(tabs[0].key)

  return (
    <LightGrayBgWrapper>
      <div className="bg-white py-3 shadow">
        <DynamicFilterBar filterTabs={tabs} activeTab={activeTab} setActiveTab={setActiveTab} barType="top-bar" />
      </div>

      {activeTab === 'roles' && <Roles />}
      {activeTab === 'permissions' && <Permissions />}
      {activeTab === 'admins' && <AdminsTab />}
      {activeTab === 'customPermissions' && <CustomPermissions />}
      {activeTab === 'activityLog' && <ActivityLog />}
    </LightGrayBgWrapper>
  )
}

export default Admins